// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"fb6dac73","80":"145210a3","358":"6174a4e2","496":"94385610","748":"deac8f35","763":"49a2b398","835":"8090331c","926":"ae681462"}[chunkId] + ".chunk.js";
};